/**
 * @Event 方法
 * @description: 生成[1, 100]的随机数
 * */
export function makePassword() {
  return { randomNum: Math.floor(Math.random() * (10 - 1 + 1)) + 1 };
}
